<template>
    <div>
        <van-nav-bar
                title="我的优惠券"
                left-text="返回"
                right-text=""
                left-arrow
                @click-left="onNavClickLeft"
        />

        <van-tabs v-model="activeIndex">
            <van-tab title="未使用">
                <coupon-list :p_action="1" />
            </van-tab>
            <van-tab title="已使用">
                <coupon-list :p_action="2" />
            </van-tab>
            <van-tab title="已失效">
                <coupon-list :p_action="3" />
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
    import CouponList from "../../components/Coupon/CouponList";

    export default {
        name: "MyCoupons",
        components: {CouponList},
        data(){
            return{
                activeIndex:this.$route.params.active?this.$route.params.active:0,
            }
        },
        methods:{
            onNavClickLeft(){
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>

</style>
